/* DailyTask  */
// import { FEATURES } from '@constants/Text'
import { registrar } from '@modules/aawz-intelligence-v2/ui-registry'
import registryClients from './ia/registry'
import { registrarConfirmadorDeSegmentacao } from './ia/confirmadores'
import * as moduleClients from './store'

// export const PERMISSION = FEATURES.ASSETS_MATURITY

export function clientsModule({ store }) {
  // ⚠️ Guarda de REENTRADA (padrão do `modules/crm/index.js:9-11`). Sem ela,
  // uma segunda chamada registraria o store de novo e cairia no `registrar`
  // abaixo, que RECUSA chave repetida por desenho (override silencioso entre
  // módulos é bug) — o boot passaria a estourar em vez de ignorar.
  if (typeof store.hasModule === 'function' && store.hasModule('moduleClients')) {
    return
  }

  store.registerModule('moduleClients', {
    ...moduleClients,
    namespaced: true,
  })

  // O cartão do módulo dentro da conversa (spec-009, [T011]). O MÓDULO se
  // registra e o agregado só consulta — é o que permite o `chat-message.vue`
  // desenhar o resumo de um cliente sem importar nada daqui.
  //
  // Aqui, e não numa view: o cartão pode chegar em QUALQUER conversa (a do
  // chat do CRM, a do Consultor, a do Especialista Fee-Based), e registrar na
  // view faria o mesmo `tool_result` virar cartão numa tela e `fallback-card`
  // na outra. `src/modules/index.js` roda uma vez, no boot, antes de qualquer
  // thread montar.
  registrar(registryClients)

  // O confirmador do cartão de segmentação (spec-005, [T032]): marcar exceção
  // re-executa a tool com a lista completa, e é ele que monta essa frase. Aqui
  // pelo mesmo motivo do `registrar` acima — o cartão chega em qualquer
  // conversa, e registrar numa view faria o clique morrer na outra.
  registrarConfirmadorDeSegmentacao()
}

// /**
//  * Enquanto o módulo estiver em beta, vai apontar para a tela antiga.
//  * @type {boolean}
//  */
// export const IS_BETA_DAILY_TASKS = false
